// src/modules/app-views/serviceOrders/pages/Document/components/CardHeaderColumn3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { DollarOutlined, CalendarOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderColumn3 = ({
  showTotal = true,
  showIssueDate = true,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const grandTotal = record?.grandTotal;
  const issueDate = record?.issueDate && parseDateToDisplay({ date: record.issueDate });

  const formattedTotal = grandTotal
    ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(grandTotal)
    : null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'grandTotal',
      icon: <DollarOutlined />,
      label: formattedTotal,
      tooltipText: translateX('grand_total'),
      tooltipPlacement: 'right',
      hidden: !showTotal,
    },
    {
      key: 'issueDate',
      icon: <CalendarOutlined />,
      label: issueDate,
      tooltipText: translateX('issue_date'),
      tooltipPlacement: 'right',
      hidden: !showIssueDate,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => i?.label && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderColumn3;
